export const module = {
  info: {
    name: 'voip-customer',
    caption: 'voip customer',
    viewGroup: 'users'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Customers Rates',
    icon: 'el-icon-user',
    routeName: 'module->voip-customer->list->page',
    routeParams: { listPage: 1}
  }
}

export default module
